import { AccountSettingsTab } from '@components/layouts/Truva/AccountSettings/AccountSettings';
import { PARAMETERS, EVENT_TYPES } from '@root/tracking/constants';

type AccountSettingsPageLoadAction = {
  type: 'ACCOUNT_SETTINGS_PAGE_LOADED';
  payload: {
    meta: {
      analytics: {
        eventType: 'page';
        event: 'professional info page' | 'tourbook contact info page';
      };
    };
  };
};

// eslint-disable-next-line import/prefer-default-export
export const loadedPage = (
  tab: NonNullable<AccountSettingsTab>,
): AccountSettingsPageLoadAction => ({
  type: 'ACCOUNT_SETTINGS_PAGE_LOADED',
  payload: {
    meta: {
      analytics: {
        eventType: EVENT_TYPES.page,
        event:
          tab === 'professional_info'
            ? PARAMETERS.professionalInfoPage
            : PARAMETERS.tourbookContactInfoPage,
      },
    },
  },
});
